import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Pagination from 'react-js-pagination'

import Filter from '../components/CertifiedBlackBelts/Filter'
import List from '../components/CertifiedBlackBelts/List'
import AxiosFetcher from '../components/axiosFetcher'

import { isMobile } from 'react-device-detect'

import i18n from '../i18n'

// A name search only leaves once the visitor has stopped typing for this long. The
// fetcher's 500ms default meant anyone typing slower than that spent one request per
// character, which is enough to trip the per-IP limit on the endpoint mid-search.
const NAME_SEARCH_DEBOUNCE_WAIT = 1000

// One or two letters match most of the list and are almost never the search the
// visitor means, so they are treated as no filter at all rather than costing a
// request each on the way to the real query.
const MIN_NAME_LENGTH = 3

class CertifiedBlackBelts extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: {
        name: '',
        belt: '',
        academyId: '',
      },
      currentPage: 1
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    if (
      this.state.filters !== prevState.filters &&
      this.state.currentPage !== 1
    ) {
      this.handlePageChange(1)
    }
  }

  updateFilterField(e) {
    let newFilters = Object.assign({}, this.state.filters)
    newFilters[e.target.name] = e.target.value

    this.setState({ filters: newFilters })
  }

  handlePageChange(pageNumber) {
    this.setState({ currentPage: pageNumber })
  }

  searchFilters() {
    const { name, ...rest } = this.state.filters

    return { ...rest, name: name.length >= MIN_NAME_LENGTH ? name : '' }
  }

  buildPaginationFromJsonAPI(pageCount, recordCount) {
    const pageSize = 10 // NOTE: Must match backend definition

    console.table({ pageSize, recordCount, pageCount })

    return {
      from: (this.state.currentPage - 1) * pageSize + 1,
      to: pageCount === this.state.currentPage ? recordCount : this.state.currentPage * pageSize,
      pageSize: pageSize,
      lastPage: pageCount,
      totalRecords: recordCount,
    }
  }

  render() {
    return (
      <div className="container">
        <Filter
          athleteName={this.state.filters.athleteName}
          belt={this.state.filters.belt}
          academyId={this.state.filters.academyId}
          updateFilterField={this.updateFilterField.bind(this)}
          minNameLength={MIN_NAME_LENGTH}
          showNameMinLengthHint={
            this.state.filters.name.length > 0 &&
            this.state.filters.name.length < MIN_NAME_LENGTH
          }
          i18n={i18n}
        />

        <AxiosFetcher
          url={`/api/v1/athletes/black_belts_list.json?page=${this.state.currentPage}`}
          params={this.searchFilters()}
          debounceWait={NAME_SEARCH_DEBOUNCE_WAIT}
        >
          {({
            loading,
            error,
            errorStatus,
            errorBody,
            data: { data: athletes = [], meta = {} } = {},
          }) => {
            const pagination = this.buildPaginationFromJsonAPI(
              meta.pageCount,
              meta.recordCount
            )

            return (
              <React.Fragment>
                <section className="row athletes-list no-gutters">
                  <div className="col-12">
                    <List
                      athletes={athletes}
                      loading={loading}
                      error={error}
                      errorStatus={errorStatus}
                      errorBody={errorBody}
                      i18n={i18n}
                    />
                  </div>
                </section>

                <section className="row pagination-container no-gutters">
                  <div className="col-12">
                    {athletes.length && pagination.lastPage > 1 ? (
                      <React.Fragment>
                        <div className="totalizer my-2">
                          <span className="from">
                            {pagination.from == 0
                              ? pagination.from + 1
                              : pagination.from}
                          </span>
                          <span>{` ${i18n.t('pagination.to')} `}</span>
                          <span className="to">{pagination.to}</span>
                          <span>{` ${i18n.t('pagination.of')} `}</span>
                          <span className="totals">
                            {pagination.totalRecords}
                          </span>
                          <span>{` ${i18n.t(
                            'certifiedBlackBelts.componentName'
                          )}`}</span>
                        </div>

                        <div>
                          <Pagination
                            activePage={this.state.currentPage}
                            itemsCountPerPage={pagination.pageSize}
                            totalItemsCount={pagination.totalRecords}
                            pageRangeDisplayed={isMobile ? 3 : 5}
                            onChange={this.handlePageChange.bind(this)}
                            prevPageText={i18n.t('pagination.previous')}
                            nextPageText={i18n.t('pagination.next')}
                            hideFirstLastPages={true}
                            itemClassNext={'next-page'}
                            itemClassPrev={'prev-page'}
                          />
                        </div>
                      </React.Fragment>
                    ) : null}
                  </div>
                </section>
              </React.Fragment>
            )
          }}
        </AxiosFetcher>
      </div>
    )
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <CertifiedBlackBelts />,
    document.querySelector('#cert-black-belts')
  )
})
